import { Component, OnInit, Input } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cxone-call-arrival-settings',
    templateUrl: './cxone-call-arrival-settings.component.html',
    styleUrls: ['./cxone-call-arrival-settings.component.scss']
})
export class CxoneCallArrivalSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;

    dataValue: Date;
    mode = 'page';
    isValidValue = true;
    hourInterval = 4;
    minDate: Date;
    maxDate: Date;
    defaultDate: Date;
    useEndDateTime = false;

    constructor(
        private cvLocalizationService: CVLocalizationService,
    ) { }

    async ngOnInit() {
        const today = new Date();
        this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7, 0, 0, 0);
        this.maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 30, 0);
        this.defaultDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
        await this.cvLocalizationService.GetSection('CXOne_Call_Arrival_Module');
        this.moduleManager.addSetting({
            name: 'EndDateTime',
            required: true,
            getValue: () => new Date(this.dataValue.getTime() - (this.dataValue.getTimezoneOffset() * 60 * 1000)).toISOString().slice(0, -1), // keep timezone and remove trailing 'Z'
            onSettingLoaded: value => {
                if (!value) {
                    this.dataValue = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                } else {
                    this.dataValue = new Date(value);
                }
            },
            defaultValue: this.defaultDate
        });
        this.moduleManager.addSetting({
            name: 'HourInterval',
            required: true,
            getValue: () => this.hourInterval,
            onSettingLoaded: value => {
                this.hourInterval = value ? value : 4;
            },
            defaultValue: 4
        });
        this.moduleManager.addSetting({
            name: 'UseEndDateTime',
            required: true,
            getValue: () => this.useEndDateTime,
            onSettingLoaded: value => {
                this.useEndDateTime = value ? value : false;
            },
            defaultValue: false
        });
        this.moduleManager.customSettingsAdded = true;
    }

    dateValueChanged(event: string) {
        if (this.defaultDate.toString() != event) {
            this.useEndDateTime = true;
        } else {
            this.useEndDateTime = false;
        }
    }
}